import { graphql } from "gatsby";
import * as React from "react";

import HomePageComponent from "../components/home/homePageComponent";
import Layout from "../components/layout";
import NavigateToParentSite from "../components/navigateToParentSite";
import Seo from "../components/seo";
import { ThemeContext } from "../context/ThemeContext";

export default function IndexPage(props) {
  const { data, location } = props;
  const { page } = data;

  // console.debug("IndexPage");

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={page?.title ?? "Home"}
          containerClass={"w-full mx-auto homepage stickyContainer"}
          brandingOpts={{ ...theme }}
          showMobileStickyFooter={true}
          showGrantsBanner={false}
          updateOnScroll={false}
        >
          {location.pathname === "/" ? (
            <HomePageComponent
              data={data}
              peopleDomain={theme?.peopleDomain}
              {...theme}
            />
          ) : (
            <NavigateToParentSite />
          )}
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
}

export const Head = ({ data }) => {
  const page = data?.page ?? {};
  return (
    <Seo
      title={page?.seoLegacy?.title ?? page?.seo?.title ?? page.title}
      description={page?.seoLegacy?.description ?? page?.seo?.description}
      image={page?.globalConfig?.backgroundImage?.sourceUrl}
      translations={page?.translations}
      lang={page?.locale}
      meta={[
        {
          name: "robots",
          content: page?.seoLegacy?.robots ?? page?.seo?.robots
        }
      ]}
    />
  );
};

export const pageQuery = graphql`
  query {
    page: wpPage(slug: { eq: "home-page" }) {
      ...HomepageFragment
    }

    genericDetails: wp {
      globalProgramConfig: gviConfigSettings {
        acfGenericGlobalConfig {
          ...ExclusiveOffersFragment
        }
      }
    }
  }
`;
